/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class Planos {
    public static inicializar() {
      var plano = new App.Planos();
      plano.inicializarEventos();
    }
  }
}

namespace App {
  export class Planos {
    private ajax: IAjax;

    private elementoLinkPagamento: JQuery = $(".link-pagamento");
    private elementoAcaoFormularioLinkPagamento: JQuery = $("#formLinkPagamento");
    private elementoBotaoAssinarComCartao: JQuery = $(".mercadopago-button");
    private elBtIncrement: JQuery = $(".increment");
    private elBtDecrement: JQuery = $(".decrement");

    private elInputQuantidadeContas: JQuery = $("#quantidadeContas");
    private elAbaMeses: JQuery = $(".aba-meses");
    private elSelectCurrency: JQuery = $("#currency");

    private elBtMaisInfoVCloube: JQuery = $(".btn-mais-informacoes-vCloube");
    private elBtDuvidaSobrePagamento: JQuery = $(".duvida-sobre-pagamento");

    private elBtAumentar: JQuery = $(".aumentarQuantidade");
    private elBtDiminuir: JQuery = $(".diminuirQuantidade");
    private elCampoNumero: JQuery = $(".numero");
    private qtdMaxContas: number = 10000;
    private elSectionGerenciarPlano: JQuery = $("#sectionGerenciarPlano");

    private planos: IPlano[] = null;
    private util: any = null;

    private dadosPlanoUpgrade: {
      nomePlano: string; quantidadeContas: any; idPlano: number; tipoPrecoPlano: string; saldo: number; valorPlanoComDesconto: string
      valorUpgradeFormatado: string; precoPlanoFormatado: string; saldoFormatado: string; descontoPlano: string,tipoPrecoPlanoDescricao: string
    } = { nomePlano: '',quantidadeContas: 0,idPlano: 0,tipoPrecoPlano: '',saldo: 0,valorUpgradeFormatado: '',precoPlanoFormatado: '',saldoFormatado: '',descontoPlano: '',valorPlanoComDesconto: '',tipoPrecoPlanoDescricao: '' };

    public inicializarEventos() {
      this.elementoLinkPagamento.on('click',(e) => { this.aoIniciarFormularioLinkPagamento(e); });
      this.ajax = new App.Ajax();
      this.elementoBotaoAssinarComCartao.on('click',() => { this.ajax.recarregarNaoLogado("/login") });
      this.elBtIncrement.on('click',(e) => { this.aoIncrementarValor(e); });
      this.elBtDecrement.on('click',(e) => { this.aoDecrementarValor(e); });

      this.elInputQuantidadeContas.on('change',(e) => { this.aoAlterarQuantidadeContas(e); });
      this.elAbaMeses.on('click',(e) => { this.aoAlterarAbaMeses(e); });
      this.elSelectCurrency.on('change',(e) => { this.aoAlterarCurrency(e); });
      this.elBtMaisInfoVCloube.on('click',(e) => { this.aoClicarBtnMaisInformacoes(e); });
      this.elBtDuvidaSobrePagamento.on('click',(e) => { this.aoClicarDuvidaSobrePagamento(e); });

      this.elBtAumentar.on('click',(e) => { this.aoExecutarAcao(e,+5); });
      this.elBtDiminuir.on('click',(e) => { this.aoExecutarAcao(e,-5); });
      this.elCampoNumero.on('blur',(e) => { this.aoExecutarAcao(e); });
      this.elCampoNumero.on('keydown',(e) => {
        let timer;
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.aoExecutarAcao(e);
        },1000); // meio segundo sem teclar
      });

      this.util = new Util();
      this.planos = this.elSectionGerenciarPlano.data("planos");
      this.aoEnviarContatoComprovante();
    }

    private aoIniciarFormularioLinkPagamento(e: JQueryEventObject) {
      this.elementoAcaoFormularioLinkPagamento.find('input[name=nome_plano]').val($(e.target).data('nome-plano'));
      this.elementoAcaoFormularioLinkPagamento.find('input[name=id_plano]').val($(e.target).data('id-plano'));
      this.elementoAcaoFormularioLinkPagamento.find('input[name=valor_plano]').val($(e.target).data('valor-plano'));
    }

    private aoIncrementarValor(e: JQueryEventObject) {
      var campoValor = $(e.currentTarget).parents('.input-group').find('input');
      var campoValorMax = $(e.currentTarget).parents('.input-group').find('input').data('max');
      var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
      var campoValorPadrao = $(e.currentTarget).parents('.input-group').find('input').data('default');
      if (App.Util.ehCampoTextoVazio(campoValor)) {
        campoValor.val(campoValorPadrao).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var valor = App.Util.obterInteiroDaString(campoValor.val());
      if (!$.isNumeric(valor)) {
        return;
      }

      if (valor >= campoValorMax) {
        $(e.currentTarget).prop('disabled',true);
        campoValor.val(campoValorMax).trigger('input').trigger('focusout').trigger('change');;
        return;
      }

      var campoValorIncrementado = App.Util.incrementarValorNumerico(valor);
      campoValor.val(campoValorIncrementado).trigger('input').trigger('focusout').trigger('change');

      if (campoValorIncrementado > campoValorMin) {
        $('.decrement').prop('disabled',false);
      }
    }

    private aoDecrementarValor(e: JQueryEventObject) {
      var campoValor = $(e.currentTarget).parents('.input-group').find('input');
      var campoValorMax = $(e.currentTarget).parents('.input-group').find('input').data('max');
      var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
      var campoValorPadrao = $(e.currentTarget).parents('.input-group').find('input').data('default');

      if (App.Util.ehCampoTextoVazio(campoValor)) {
        campoValor.val(campoValorPadrao).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var valor = App.Util.obterInteiroDaString(campoValor.val());
      if (!$.isNumeric(valor)) {
        return;
      }

      if (valor <= campoValorMin) {
        $(e.currentTarget).prop('disabled',true);
        campoValor.val(campoValorMin).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var campoValorDecrementado = App.Util.decrementarValorNumerico(valor);
      campoValor.val(campoValorDecrementado).trigger('input').trigger('focusout').trigger('change');

      if (campoValorDecrementado < campoValorMax) {
        $('.increment').prop('disabled',false);
      }
    }

    private aoAlterarQuantidadeContas(e: JQueryEventObject) {
      $('.plano-dinamico').hide();
      $('.plano-dinamico-cloud').hide();
      $('#planoDinamico' + $(e.currentTarget).val() + $('.aba-meses.active').data('quantidadeMeses')).show();
      $('#planoDinamicoCloud' + $(e.currentTarget).val() + $('.aba-meses.active').data('quantidadeMeses')).show();
    }
    private aoAlterarAbaMeses(e: JQueryEventObject) {
      $('.plano-dinamico').hide();
      $('.plano-dinamico-cloud').hide();
      $('#planoDinamico' + this.elInputQuantidadeContas.val() + $(e.currentTarget).data('quantidadeMeses')).show();
      $('#planoDinamicoCloud' + this.elInputQuantidadeContas.val() + $(e.currentTarget).data('quantidadeMeses')).show();
    }
    private aoAlterarCurrency(e: JQueryEventObject) {
      window.location.href = $(e.currentTarget).data('urlRedirect').replace("?",$(e.currentTarget).val());
      return;
    }

    private aoClicarBtnMaisInformacoes(e: JQueryEventObject) {
      $('#mensagem-modal-vcloud').show();
    }

    private aoClicarDuvidaSobrePagamento(e: JQueryEventObject) {
      $('#mensagem-modal-vcloud').hide();
    }

    private aoExecutarAcao(e: JQueryEventObject,incremento: number = 0): void {
      const campo = incremento === 0
        ? $(e.currentTarget) // digitação
        : $(e.currentTarget).closest(".input-group").find("input"); // clique em botão
      this.processarCampo(campo,incremento);
    }

    private processarCampo(campo: JQuery,incremento: number = 0): void {
      let campoValorMin = campo.data("min");
      let campoValorMax = this.qtdMaxContas;
      let valor = App.Util.obterInteiroDaString(campo.val());

      this.dadosPlanoUpgrade.nomePlano = campo.data("nome-plano");
      this.dadosPlanoUpgrade.idPlano = campo.data("id-plano");
      this.dadosPlanoUpgrade.tipoPrecoPlano = campo.data("tipo-preco-plano");
      this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao = campo.data("tipo-preco-plano-descricao");
      this.dadosPlanoUpgrade.saldo = campo.data("saldo");

      if (!$.isNumeric(valor)) {
        valor = campoValorMin;
      }

      let novoValor = valor + incremento;
      let arredondado = this.arredondarParaMultiplo(novoValor,5);

      if (arredondado < campoValorMin) arredondado = campoValorMin;
      if (arredondado > campoValorMax) arredondado = campoValorMax;

      campo.val(arredondado).trigger("input").trigger("change").trigger("focusout");
      this.dadosPlanoUpgrade.quantidadeContas = this.elInputQuantidadeContas.val();
      this.efetuarCalculoUpgrade();
    }

    private async efetuarCalculoUpgrade(): Promise<void> {
      try {
        const PRECO_PLANO_PADRAO = 'preco_padrao';
        const precoPlanoPadrao = await this.util.getPrecoPlano(this.dadosPlanoUpgrade.idPlano,this.dadosPlanoUpgrade.quantidadeContas,PRECO_PLANO_PADRAO,this.planos);
        let precoPlanoComDesconto = precoPlanoPadrao;
        let descontoPlano = 0;

        if (this.dadosPlanoUpgrade.tipoPrecoPlano !== PRECO_PLANO_PADRAO) {
          precoPlanoComDesconto = await this.util.getPrecoPlano(this.dadosPlanoUpgrade.idPlano,this.dadosPlanoUpgrade.quantidadeContas,this.dadosPlanoUpgrade.tipoPrecoPlano,this.planos);
          descontoPlano = precoPlanoPadrao - precoPlanoComDesconto;
        }

        if (this.dadosPlanoUpgrade.tipoPrecoPlano === PRECO_PLANO_PADRAO) {
          descontoPlano = 0;
        }

        if (!precoPlanoPadrao) {
          $("#valPlanoDesejado").val(0);
          return;
        }

        let valorUpgrade: any = (this.dadosPlanoUpgrade.tipoPrecoPlano !== PRECO_PLANO_PADRAO ? precoPlanoComDesconto : precoPlanoPadrao) - this.dadosPlanoUpgrade.saldo;

        this.dadosPlanoUpgrade.valorUpgradeFormatado = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(valorUpgrade);
        this.dadosPlanoUpgrade.precoPlanoFormatado = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(precoPlanoPadrao);
        this.dadosPlanoUpgrade.saldoFormatado = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(this.dadosPlanoUpgrade.saldo);
        this.dadosPlanoUpgrade.descontoPlano = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(descontoPlano);
        this.dadosPlanoUpgrade.valorPlanoComDesconto = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(precoPlanoComDesconto);

        //console.log('valorUpgrade:',valorUpgrade,'valorFormatado:',this.dadosPlanoUpgrade.valorUpgradeFormatado,'precoPlanoReal:',this.dadosPlanoUpgrade.precoPlanoFormatado,'saldo:',this.dadosPlanoUpgrade.saldoFormatado);
        this.preencherViewUpgrade();
      } catch (err) {
        console.error("Erro ao calcular preço do plano:",err);
        $("#valPlanoDesejado").val(0);
      }
    }

    private preencherViewUpgrade() {
      $('#descricaoPlanoDesejado').text(`${this.dadosPlanoUpgrade.nomePlano} ${this.dadosPlanoUpgrade.quantidadeContas} contas`);
      $('.saldoRestante').text(`${this.dadosPlanoUpgrade.saldoFormatado}`);
      $('#valPlanoDesejado').text(`${this.dadosPlanoUpgrade.precoPlanoFormatado}`);
      $(".valUpgrade").html(`<b>${this.dadosPlanoUpgrade.valorUpgradeFormatado}</b>`);
      $('#desconto').text(`${this.dadosPlanoUpgrade.descontoPlano} (${this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao})`);
      $('#ValorPlanoDesconto').text(`${this.dadosPlanoUpgrade.valorPlanoComDesconto} `);
    }

    private arredondarParaMultiplo(valor: number,multiplo: number): number {
      return Math.round(valor / multiplo) * multiplo;
    }

  private aoEnviarContatoComprovante(): void {
    const forms = document.querySelectorAll('.contact-form') as NodeListOf<HTMLFormElement>;
    const botoesEnviar = document.querySelectorAll('.bt-enviar-comprovante') as NodeListOf<HTMLButtonElement>;

    Array.from(forms).forEach((form, index) => {
        const botaoEnviar = botoesEnviar[index];
        if (botaoEnviar) {
            form.addEventListener('submit', () => {
                botaoEnviar.disabled = true;
                botaoEnviar.textContent = 'Enviando...';
            });
        }
    });
}


  }
}
